import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=0f185067&scoped=true&"
import script from "./NotificationsBell.vue?vue&type=script&lang=js&"
export * from "./NotificationsBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBell.vue?vue&type=style&index=0&id=0f185067&prod&scoped=true&lang=css&"
import style1 from "./NotificationsBell.vue?vue&type=style&index=1&id=0f185067&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f185067",
  null
  
)

export default component.exports